import React, { createContext, useContext, useState, useEffect } from "react";
import { Helmet } from 'react-helmet';

// ایجاد Context
const SeoContext = createContext();

// کامپوننت SeoManager
const SeoManager = ({ children }) => {
	const [seoData, setSeoData] = useState({
		title: '',
		description: '',
		keywords: '',
		image: ''
	});

	return (
		<SeoContext.Provider value={{ seoData, setSeoData }}>
			{/* تنظیم تگ‌های SEO */}
			<SeoTags seoData={seoData} />
			{children}
		</SeoContext.Provider>
	);
};

// کامپوننت داخلی برای تنظیم تگ‌های HTML
const SeoTags = ({ seoData }) => {
	if (seoData) {
		return (
			<Helmet>
				{seoData.title && <meta property="og:title" content={seoData.title} />}
				{seoData.image && <meta property="og:image" content={seoData.image} />}
				{seoData.description && <meta property="og:description" content={seoData.description} />}
				{seoData.keywords && <meta name="keywords" content={seoData.keywords} />}
			</Helmet>
		);
	}

};

export const useSeo = () => useContext(SeoContext);

export default SeoManager;
